/**
 *  @description 拼接PCM数据 
 *  @param { Object } data 数据集合
 */

const getPcm = (data) => {
    let resourceType = data.resourceType || 3;
    let mediaId = data.authorId || '';
    let contentId = data.id || '';
    let pcm = data.pcm || '';
    let type = data.type || '';
    let adInfo = data.adInfo || '';
    let pcmCode = resourceType + '|' + mediaId + '|' + contentId + '|' + pcm + '|' + type + '|' + adInfo;
    return pcmCode
}

export default getPcm